import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosApi from "../../utils/httpClient";

const name = "jobcategories";
const initialState = {
  jobcategories: [],
  loading: false,
  error: null,
};

export const fetchJobcategories = createAsyncThunk(
  "jobcategories/fetchJobcategories",
  async () => {
    const data = await axiosApi.get(
      `${process.env.REACT_APP_BASE_URL}job-category`
    );
    return data.data;
  }
);

const jobcategoriesSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchJobcategories.pending, (state) => {
      state.jobcategories = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchJobcategories.fulfilled, (state, action) => {
      state.jobcategories = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(fetchJobcategories.rejected, (state, action) => {
      state.jobcategories = [];
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default jobcategoriesSlice.reducer;
